import React, { Component } from 'react';

import IChatOptions from '../../interfaces/IChatOptions';
import { logInfo } from '../../lib/logging';
import WidgetGenerator from '../WidgetGenerator/WidgetGenerator';
import { Container } from './styled';

export interface IDriverProps {
  options: IChatOptions;
}

export interface IDriverState {
  clientKey: string;
  initialMessage: string;
  options: string;
  showWidgetGenerator: boolean;
  optionsForOpen: string;
}

class Driver extends Component<IDriverProps, IDriverState> {
  protected script: HTMLScriptElement | null = null;

  constructor(props: IDriverProps) {
    super(props);
    this.state = {
      showWidgetGenerator: false,
      clientKey: 'haller',
      initialMessage: 'Hello, this is the greeting message.',
      options:
        '{"env": "integration", "position": "right", "modal": true, "modalTransparency": 80, "primaryAccentColor": "#06776D", "initialResponses": ["hi", "hello"]}',
      optionsForOpen: '{}',
    };
  }

  public render() {
    const env = process.env.REACT_APP_AWS_ACCOUNT_KEY;
    if (env === 'production') {
      return <WidgetGenerator />;
    }

    if (this.state.showWidgetGenerator) {
      return <WidgetGenerator />;
    }

    return (
      <Container>
        <div>{`DRIVER AREA: ${env}`}</div>
        <br />
        <div>
          <div>
            <div>Greeting: </div>
            <textarea
              value={this.state.initialMessage}
              onChange={(e) => this.setState({ initialMessage: e.target.value })}
            />
          </div>
          <div>
            <div>Widget Options (JSON format): </div>
            <textarea value={this.state.options} onChange={(e) => this.setState({ options: e.target.value })} />
          </div>
          <br />
          <div>
            <div>Open Options (JSON format): </div>
            <textarea
              value={this.state.optionsForOpen}
              onChange={(e) => this.setState({ optionsForOpen: e.target.value })}
            />
          </div>
          <button onClick={() => this.reset()}>Reset</button>
          <br />
          <br />
          <div>
            <div>Client: </div>
            <select value={this.state.clientKey} onChange={this.handleClientChange}>
              <option value='haller'>Haller</option>
              <option value='homex'>HomeX</option>
              <option value='dyr65ythgutiylhi8rtd6e54rte522'>Haller Affiliate</option>
              <option value='duthie'>Duthie</option>
              <option value='jackson'>Jackson</option>
              <option value='fujitsu'>Fujitsu</option>
              <option value='goettl'>Goettl</option>
              <option value='airco'>Airco</option>
              <option value='jeffersonahv'>Jefferson AHV (ST)</option>
              <option value='genzryan'>Genz-Ryan (Room Issue Buttons)</option>
              <option value='keenerstsc'>Keener's Test Client (ST)</option>
            </select>
          </div>
          <br />
          <br />
          <div>Show Widget Customizer</div>
          <select value={this.state.showWidgetGenerator ? 'true' : 'false'} onChange={this.handleCustomizerChange}>
            <option value='false'>False</option>
            <option value='true'>True</option>
          </select>
        </div>
        <br />
        <button onClick={() => this.update()}>Update</button>
        <button onClick={() => this.open()}>Open</button>
      </Container>
    );
  }

  private handleClientChange = (event: any) => {
    this.setState({ clientKey: event.target.value });
  };

  private handleCustomizerChange = (event: any) => {
    this.setState({ showWidgetGenerator: event.target.value === 'true' });
  };

  private addScript() {
    const env = process.env.REACT_APP_AWS_ACCOUNT_KEY;

    const { options } = this.state;

    const chatOptions = JSON.parse(options);

    (window as any).hxc4webOptions = {
      apiKey: this.state.clientKey,
      env,
      target: process.env.REACT_APP_CHAT_HOST,
      initialMessage: this.state.initialMessage,
      modal: true,
      modalTransparency: 30,
      ...chatOptions,
    };
    logInfo('hxc4webOptions', { context: { options: (window as any).hxc4webOptions } });

    const script = document.createElement('script');

    script.src = `/widget.js?ts=${new Date().getTime()}`;
    script.async = true;
    script.onload = () => {
      (window as any).hxc4web.open(JSON.parse(this.state.optionsForOpen));
    };

    this.script = document.body.appendChild(script);
  }

  private open() {
    if (!this.script) {
      this.addScript();
    } else {
      (window as any).hxc4web.open(JSON.parse(this.state.optionsForOpen));
    }
  }

  private update() {
    if (this.script) {
      document.body.removeChild(this.script);
      const el = document.getElementsByClassName('hxc4webroot')[0];
      document.body.removeChild(el);
      this.script = null;
    }
    this.addScript();
  }

  private reset() {
    (window as any).hxc4web.reset();
  }
}

export default Driver;
